import Repo from './Repository'

export default {
  getSteps: (tour, route, mobile) => Repo.createSteps(tour, route, mobile),
  getHeader: (tour, currentStepElement, mobile) => Repo.createHeader(tour, currentStepElement, mobile),
  getTourStatus: () => Repo.getTourStatus(),
  getFooter: (currentStepElement) => Repo.createFooter(currentStepElement)
}
